/**
 * Returns the error if {@link error} is an instance of {@link Error}.
 * Otherwise, stringify {@link error} and wrap it in an {@link Error}.
 */
export function asError(error: unknown): Error {
  if (error instanceof Error) return error;
  if (typeof error === "object") return new Error(JSON.stringify(error));
  return new Error(String(error));
}
